var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content
    ? _c(
        "i",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip.top.center",
              value: { html: true, content: _vm.content },
              expression: "{ html: true, content: content }",
              modifiers: { top: true, center: true }
            }
          ],
          staticClass: "fas fa-question-circle icon blue fa-lg",
          attrs: { tabindex: "0" }
        },
        [
          _vm.srOnly
            ? _c("span", { staticClass: "sr-only" }, [
                _vm._v("-. " + _vm._s(_vm.content))
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }